<script>
//询价单列表的数据模型
export default {
    //返回数据模型实例
    new : function () {
        return [
            {
                prop : "createDate",
                label : "时间",
                width : 120,
                visible: false,
                sortable: false,
            },
            {
                prop : "newUsers",
                label : "新增",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "disNewUsers",
                label : "去重新增",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "regDevices",
                label : "激活",
                width : 120,
                visible: true,
                sortable: false,
            },
            {
                prop : "activeUsers",
                label : "活跃",
                width : 120,
                visible: true,
                sortable: false,
            },
            {
                prop : "cost",
                label : "消耗",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "rmbCost",
                label : "rmb消耗",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "price",
                label : "单价(激活)",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "regPrice",
                label : "单价(注册)",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "rechargeUsers",
                label : "付费人数",
                width : 120,
                visible: true,
                sortable: false,
            },
            {
                prop : "rechargePrice",
                label : "充值",
                width : 120,
                visible: true,
                sortable: false,
            },
           
             
            {
                prop : "orders",
                label : "订单数",
                width : 120,
                visible: false,
                sortable: false,
            },{
                prop : "newRechargeUsers",
                label : "新增付费人数",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "newRechargePrice",
                label : "新增充值",
                width : 120,
                visible: true,
                sortable: false,
            },
             {
                prop : "roi",
                label : "首日ROI",
                width : 120,
                visible: true,
                sortable: false,
            },
            {
                prop : "totalPrice",
                label : "累计充值",
                width : 120,
                visible: true,
                sortable: false,
            },
             {
                prop : "totalRoi",
                label : "累计ROI",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "show",
                label : "展示",
                width : 120,
                visible: true,
                sortable: false,
            },
            {
                prop : "click",
                label : "点击",
                width : 120,
                visible: true,
                sortable: false,
            },
            {
                prop : "arppu",
                label : "arppu",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "arpu",
                label : "arpu",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "payRate",
                label : "付费率",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "newPayRate",
                label : "新增付费率",
                width : 120,
                visible: true,
                sortable: false,
            },
            
            {
                prop : "validPlay",
                label : "有效播放",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "comment",
                label : "评论数",
                width : 120,
                 visible: false,
                sortable: false,
            },{
                prop : "like",
                label : "点赞数",
                width : 120,
                visible: false,
                sortable: false,
            },{
                prop : "register",
                label : "应用下载-注册",
                width : 120,
                visible: true,
                sortable: false,
            },
            {
                prop : "payCount",
                label : "应用下载-付费数",
                width : 140,
                visible: false,
                sortable: false,
            },
            {
                prop : "active",
                label : "应用下载-激活",
                width : 120,
                visible: true,
                sortable: false,
            },{
                prop : "comment",
                label : "互动数据-评论数",
                width : 130,
                visible: true,
                sortable: false,
            },{
                prop : "share",
                label : "互动数据-分享数",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "follow",
                label : "互动数据-关注数",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "interactPerCost",
                label : "互动数据-单次互动成本",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "iesMusicClick",
                label : "互动数据-音乐查看数",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "iesChallengeClick",
                label : "互动数据-挑战赛查看数",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "homeVisited",
                label : "互动数据-主页访问量",
                width : 130,
                 visible: false,
                sortable: false,
            },{
                prop : "downloadFinish",
                label : "应用下载-安卓下载完成",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "inAppUv",
                label : "应用下载-到达uv",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "inAppCart",
                label : "应用下载-加入购物车",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "inAppDetailUv",
                label : "应用下载-详情页到站uv",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "downloadStart",
                label : "应用下载-安卓下载开始",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "clickInstall",
                label : "应用下载-点击安装数",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "inAppPay",
                label : "应用下载-付费",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "inAppOrder",
                label : "应用下载-提交订单",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "installFinish",
                label : "应用下载-安卓安装完成",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "vote",
                label : "落地页-投票",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "redirect",
                label : "落地页-页面跳转",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "lottery",
                label : "落地页-抽奖",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "shopping",
                label : "落地页-商品购买",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "wechat",
                label : "落地页-微信",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "consult",
                label : "落地页-在线咨询",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "qq",
                label : "落地页-QQ咨询数",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "phone",
                label : "落地页-电话拨打数",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "button",
                label : "落地页-按钮button",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "mapSearch",
                label : "落地页-地图搜索",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "view",
                label : "落地页-关键页面浏览",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "phoneConfirm",
                label : "落地页-智能电话确认拨打",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "consultEffective",
                label : "落地页-智能电话有效咨询",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "totalPlay",
                label : "视频-总播放",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "validPlay",
                label : "视频-有效播放",
                width : 130,
                visible: true,
                sortable: false,
            },{
                prop : "wifiPlay",
                label : "视频-wifi播放",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "play25FeedBreak",
                label : "视频-播放25%进度总数",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "play50FeedBreak",
                label : "视频-播放50%进度总数",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "play75FeedBreak",
                label : "视频-播放75%进度总数",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "play100FeedBreak",
                label : "视频-播放100%进度总数",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "playDurationSum",
                label : "视频-播放时长",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "form",
                label : "附加创意-表单提交",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "advancedCreativePhoneClick",
                label : "附加创意-电话按钮",
                width : 130,
                visible: false,
                sortable: false,
            },
            {
                prop : "advancedCreativeCounselClick",
                label : "附加创意-在线咨询",
                width : 130,
                visible: false,
                sortable: false,
            },{
                prop : "advancedCreativeFormClick",
                label : "附加创意-表单提交",
                width : 130,
                visible: false,
                sortable: false,
            },
        ]
    }
}
</script>


// WEBPACK FOOTER //
// src/toutiao/models/advertiserModel.vue